import axios from '../../utils/axios';
import { objectToFormData } from '../utils';

// /ActiveTickets done
// /CompleteTickets done
// /TicketData done
// /MarkTicketAsNeedsResponse done
// /PinTicket done
// /TicketUsers done
// /TicketMessages done
// /SetTicketMessagesRead done
// /AddTicket done
// /SendTicketMessage done
// /AddTicketImage done
// /EditTicket done
// /TicketPageData done
// /ToggleTicketsComplete done
// /TicketFile done

// GET

export async function getActiveTicketsData() {
  const response = await axios.get('/ActiveTickets');
  return response;
}

export async function getCompletedTicketsData({ startDate, endDate }) {
  const response = await axios.get(`/CompleteTickets?Start=${startDate}&End=${endDate}`);
  return response;
}
//get
//TicketUsers id
export async function getTicketDataData({ id }) {
  const response = await axios.get(`/TicketData?id=${id}`);
  return response;
}

export async function getTicketSummary({ ticketId }) {
  const response = await axios.post('/TicketAI/GenerateTicketSummary', objectToFormData({ ticketId }));
  return response;
}

export async function postTicketText(message, mode, instruction, signal) {
  const formData = {
    message,
    mode,
    instruction
  };
  const response = await axios.post('/TicketAI/RewriteTicketMessage', objectToFormData(formData), { signal });
  return response.data;
}

export async function getPossibleTicketUsers(facilityId, ticketCategoryId, ticketTypeId) {
  const response = await axios.get(`/PossibleTicketUsers?facilityId=${facilityId}&ticketCategoryId=${ticketCategoryId}&ticketTypeId=${ticketTypeId}`);
  return response;
}

export async function getUserFacilityTicketCategoryPermissions(facilityId) {
  const response = await axios.get(`/UserFacilityTicketCategoryPermissions?facilityId=${facilityId}`);
  return response;
}

//TicketMessages 2 params id and type, type is optional can only be order
export async function getTicketMessagesData(id) {
  const response = await axios.get(`/TicketMessages?id=${id}`);
  return response;
}
export async function getTicketMessagesFromOrdersData(id) {
  const response = await axios.get(`/TicketMessages?id=${id}&type=order`);
  return response;
}

export async function getTicketPageData() {
  const response = await axios.get('/TicketPageData');
  return response;
}

export async function getTicketCategories() {
  const response = await axios.get('/TicketCategories');
  return response;
}

export async function getTicketTypes() {
  const response = await axios.get('/TicketTypes');
  return response;
}

export async function getTicketType(id) {
  const response = await axios.get(`/TicketType?id=${id}`);
  return response;
}
export async function getOrderItemsForTicket(orderId, withPictures) {
  const response = await axios.post(`/OrderItemsForTicket?orderId=${orderId}&withPictures=${withPictures}`);
  return response;
}

export async function getRentalOrderItemsForTicket(orderId, withPictures) {
  const response = await axios.post(`/RentalOrderItemsForTicket?orderId=${orderId}&withPictures=${withPictures}`);
  return response;
}

export async function getOrdersForTicket(facilityId) {
  const response = await axios.post(`/OrdersForTicket?facilityId=${facilityId}`);
  return response;
}

//////////////////////////////////////////////////////////////////////////
//post
export async function postMarkTicketAsNeedsResponse({ ticketId }) {
  const response = await axios.post(`/MarkTicketAsNeedsResponse?ticketId=${ticketId}`);
  return response;
}
//PinTicket ticketId
export async function postPinTicket({ ticketId }) {
  const response = await axios.post(`/PinTicket?ticketId=${ticketId}`);
  return response;
}

//DeleteTicketMessage ticketMessageId
export async function postDeleteTicketMessage(ticketMessageId) {
  const response = await axios.post(`/DeleteTicketMessage?ticketMessageId=${ticketMessageId}`);
  return response;
}

//SetTicketMessagesRead id markAsUnread default false setSubticketsRead default false
export async function postSetTicketMessagesRead({ id, markAsUnread, setSubticketsRead }) {
  const response = await axios.post(`/SetTicketMessagesRead?id=${id}&markAsUnread=${markAsUnread}&setSubticketsRead=${setSubticketsRead}`);
  return response;
}

export async function postSetTicketsMessagesRead(ids, markAsUnread) {
  const response = await axios.post(`/SetTicketsMessagesRead`, objectToFormData({ids, markAsUnread}));
  return response;
}

export async function postSetTicketSubticketsMessagesRead({ id, markAsUnread }) {
  const response = await axios.post(`/SetTicketSubticketsMessagesRead?id=${id}&markAsUnread=${markAsUnread}`);
  return response;
}

export async function getTicketSubtickets(id) {
  const response = await axios.get(`/TicketSubtickets?id=${id}`);
  return response;
}

export async function postSendTicketMessage({ message, ticketNumber, notify = false, files, users, isOrderNote = false }) {
  if (!files && !message) return null;
  const formData = new FormData();
  if (files && !message) formData.append('message', files.map ? files.map((file) => file.name).join(', ') : files.name);
  if (message && message !== '' && message !== '<p><br></p>') formData.append('message', message);
  formData.append('ticketNumber', ticketNumber);
  formData.append('notify', notify);
  if (files) for (let i = 0; i < files.length; i++) formData.append('files', files[i]);
  if (users) for (let i = 0; i < users.length; i++) formData.append('addUsers', users[i]);
  const response = await axios.post(isOrderNote ? `SendOrderNoteTicketMessage` : `/SendTicketMessage`, formData);
  return response;
}

export async function postAddTicket(input) {
  const response = await axios.post('/AddTicket', objectToFormData(input));
  return response;
}

// export async function postEditTicket({ Id, FacilityId , Users, Completed,  Importance, Type ,ExtraInfo, updateType }) {
export async function postEditTicketData({ Id, value, updateType }) {
  if (updateType === 'Users') {
    const formData = objectToFormData({ Id, updateType });

    if (value) {
      for (let i = 0; i < value.length; i++) {
        formData.append(`Users[${i}].UserEmail`, value[i]);
      }

      const response = await axios.post('/EditTicket', formData);
      return response;
    }
  }

  const response = await axios.post(`/EditTicket?Id=${Id}&${updateType}=${value}&updateType=${updateType}`);
  return response;
}

export async function postToggleTicketsComplete({ ticketIds, isComplete }) {
  const response = await axios.post(
    `/ToggleTicketsComplete?${ticketIds.map((ticketId) => `tickets=${ticketId}`).join('&')}&isComplete=${isComplete}`
  );
  return response;
}

export async function advancedSearchTickets(data) {
  const response = await axios.post(`/TicketsAdvancedSearch`, objectToFormData(data));
  return response;
}

export async function postTicketBoomerang({ date, ticketId }) {
  const boomerangInSeconds = date ? Math.floor(Math.abs((new Date().getTime() - date.getTime())) / 1000)  : null;
  const response = await axios.post(`/TicketBoomerang`, objectToFormData({ boomerangInSeconds, ticketId }));
  return response;
}

export async function postTicketAutoClosure({ autoCloseOn, autoClosureId, ticketId }) {
  const autoCloseInSeconds = autoCloseOn ? Math.floor((autoCloseOn.getTime() - new Date().getTime()) / 1000)  : null;
  const response = await axios.post(`/TicketAutoClose`, objectToFormData({ autoCloseInSeconds, autoClosureId, ticketId }));
  return response;
}

export async function postTicketCategoryForm(data) {
  const response = await axios.post(`/TicketCategoryForm`, objectToFormData(data));
  return response;
}

export async function postDeleteTicketCategory(id) {
  const response = await axios.post(`/DeleteTicketCategory?id=${id}`);
  return response;
}

export async function postTickeTypeForm(data) {
  const response = await axios.post(`/TickeTypeForm`, objectToFormData(data));
  return response;
}

export async function postDeleteTicketType(id) {
  const response = await axios.post(`/DeleteTicketType?id=${id}`);
  return response;
}